import { defaultLocale, localeConfig } from 'shared/domains/languages/config';
export function transformSearchQuery(inputSearchQuery) {
    const { search } = inputSearchQuery || {};
    const { results, totalHitsCount } = search || {};
    const transformedResults = results === null || results === void 0 ? void 0 : results.map((result) => {
        var _a, _b;
        const metadataTemplateTitle = 'metadataTemplateTitle' in result ? result.metadataTemplateTitle : undefined;
        const activeLocaleCode = localeConfig.getActiveLocale().languageCode;
        const defaultLocaleCode = defaultLocale.languageCode;
        const templateLocaleTitle = (metadataTemplateTitle === null || metadataTemplateTitle === void 0 ? void 0 : metadataTemplateTitle.find((item) => item.marketLocaleCode === activeLocaleCode)) ||
            (metadataTemplateTitle === null || metadataTemplateTitle === void 0 ? void 0 : metadataTemplateTitle.find((item) => item.marketLocaleCode === defaultLocaleCode));
        return {
            id: result.id,
            entityId: result.entityId,
            entityType: result.entityType,
            createdAt: result.createdAt,
            meta: {
                highlight: (_a = result.meta) === null || _a === void 0 ? void 0 : _a.highlight,
            },
            name: (_b = templateLocaleTitle === null || templateLocaleTitle === void 0 ? void 0 : templateLocaleTitle.text) !== null && _b !== void 0 ? _b : result.name,
        };
    });
    return {
        totalHitsCount: totalHitsCount || 0,
        results: transformedResults || [],
    };
}
